// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__20r-c","bg":"Button_bg__2NPsd","text":"Button_text__3c6OV"};